import { render, staticRenderFns } from "./CombinedMatch.vue?vue&type=template&id=fa535eb8"
import script from "./CombinedMatch.vue?vue&type=script&lang=js"
export * from "./CombinedMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports